"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHmfVarValue = exports.isValidHmfColor = exports.isValidHmfVariable = void 0;
function isValidHmfVariable(hmfVar) {
    const value = getComputedStyle(document.body).getPropertyValue(hmfVar);
    return value.length > 0;
}
exports.isValidHmfVariable = isValidHmfVariable;
function isValidHmfColor(colorVar) {
    if (isValidHmfVariable(colorVar)) {
        const value = getHmfVarValue(colorVar);
        return /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(value);
    }
    return false;
}
exports.isValidHmfColor = isValidHmfColor;
function getHmfVarValue(hmfVar) {
    return getComputedStyle(document.body).getPropertyValue(hmfVar);
}
exports.getHmfVarValue = getHmfVarValue;
